"use client";

import { useFormStatus } from "react-dom";

export function GenerateAllButton({ hasSources }: { hasSources: boolean }) {
  const { pending } = useFormStatus();
  return (
    <button
      type="submit"
      className="btn btn-ai btn-ai-large"
      disabled={pending}
      title={
        hasSources
          ? "Génère 5 objectifs + 15 contenus + 15 questions, ancrés dans vos sources"
          : "Génère 5 objectifs + 15 contenus + 15 questions à partir des paramètres du cours"
      }
    >
      {pending ? (
        <>
          <span className="spinner" aria-hidden />
          Génération en cours… (1 à 2 min)
        </>
      ) : (
        <>
          Tout générer avec IA
          <span className="ai-mode live-or-mock">
            {hasSources ? "ancré dans la source" : "à partir du contexte"}
          </span>
        </>
      )}
    </button>
  );
}
